import { Functionality } from "web/types/Employee";
import { IFunctionalityMenuItem, MenuItemType } from "web/types/Menu";

import { MenuItemContext, ProcessedMenuItem } from "./types";

const handleFunctionalityMenuItem = (
  menuItem: IFunctionalityMenuItem,
  context: MenuItemContext
): ProcessedMenuItem | null => {
  const {
    functionalities,
    mbActiveEnabledSelector,
    myBenefitActiveUrl,
    myBenefitActiveMenu,
    msiUrl,
    msMenu,
    msiCartsEnabledSelector,
  } = context;

  const funcFromEmployee = functionalities?.find(
    (func) => func === menuItem.functionality
  );

  if (
    funcFromEmployee === Functionality.ENABLE_MYBENEFIT_ACTIVE &&
    mbActiveEnabledSelector &&
    myBenefitActiveUrl
  ) {
    return {
      type: MenuItemType.FUNCTIONALITY,
      code: menuItem.code,
      title: myBenefitActiveMenu ?? menuItem.title,
      url: myBenefitActiveUrl,
    };
  }

  if (
    funcFromEmployee === Functionality.ENABLE_MSI_CARDS &&
    msiCartsEnabledSelector &&
    msiUrl
  ) {
    return {
      type: MenuItemType.FUNCTIONALITY,
      code: menuItem.code,
      title: msMenu!,
      url: msiUrl,
    };
  }

  return null;
};

export default handleFunctionalityMenuItem;
